import React from 'react';
import { observer } from 'mobx-react';

import { withRouter, Route } from 'react-router-dom';

import List from './List';
import Edit from './Edit';

@withRouter
@observer
export default class MainSlides extends React.Component {
	render() {
		const rootPath = `/admin`;
		const path = `/admin/MainSlides`;
		console.log('main slides');
		return (
			<div>
				<Route exact path={path} component={() => <List rootPath={rootPath} path={path} />} />
				<Route exact path={`${path}/:id`} component={() => <Edit rootPath={rootPath} path={path} />} />
			</div>
		);
	}
}
